// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"846cd47f","672":"9138c3cb"}[chunkId] + ".chunk.js";
};